var base = require('settings/teams/team-settings');

Vue.component('spark-team-settings', {
    mixins: [base],
    data() {
        return {
            page: 'profile',
            billingpages: [{
                title: 'Payment Method',
                icon: 'credit_card',
                link: 'payment-method'
            },{
                title: 'Invoices',
                icon: 'history',
                link: 'invoices'
            }]
        };
    },
    methods: {
        usePushStateForTabs() {

            // Update active tab on load
            this.updateTab(null);
        },
        updateTab: function(tab) {

            // Get parameters from url
            var hash = window.location.hash.substring(2),
                parameters = hash.split('/');
            hash = parameters.shift();

            // On load, set active tab from url (if present) or default
            if(!tab){
                if(hash.length > 0){
                    tab = hash;
                }else{
                    tab = this.page;
                }
            }

            // Update url to active tab
            window.location.hash = '/'+tab;

            // Update Tab and run Spark functions
            this.page = tab;
            this.broadcastTabChange(this.page, parameters);
        }
    }
});
